import { useNavigate } from "react-router";

import { BIMClass, Parameter } from "../../../../../modules/shared-entities";
import Back from "../../../components/Back";
import Button from "../../../components/Button";
import RevitBuiltInParameter from "../../RevitBuiltInParameter/RevitBuiltInParameter";
import SharedParameterAttributes from "../components/SharedParameterAttributes";
import useDefineRevitParameter from "../useDefineRevitParameter";

export default function Summary(props) {
    const { revitDefinition } = props;

    const navigate = useNavigate();

    const [execute, mutation] = useDefineRevitParameter(
        props.parameterID,
        props.bimClassID,
        props.revitDefinition,
    );

    async function onSubmit() {
        const response = await execute();
        navigate(`../${ response.data.defineRevitParameter.id }`);
    }

    return (
        <>
            <Back
                as="button"
                onClick={ props.prev }
            />
            <header>
                <Parameter id={ props.parameterID } />
                <BIMClass id={ props.bimClassID } />
            </header>
            {
                revitDefinition.id
                    ? <div className="row flex"><RevitBuiltInParameter distinct id={ revitDefinition.id } /></div>
                    : <SharedParameterAttributes { ...revitDefinition } />
            }
            <footer>
                <Button onClick={ props.prev }>back</Button>
                <Button onClick={ onSubmit } disabled={ mutation.called }>create</Button>
            </footer>
        </>
    );
}
